import $ from 'jquery';
import qs from 'qs';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
    sendContactus, setLayout, setPath, setPathLayout,
    getPoliciesBasedOnAge,
    getTermsBasedOnPolicy,
    getSumAssuredValidation,
    getCalculations
} from '../../actions/Utils';
import axiosInstance, { version } from '../../config/Api';

import DatePicker from "react-datepicker";
import { DateInput } from './Dateinput';
import "react-datepicker/dist/react-datepicker.css";
import LangData from '../common/LangData';

class PremiumcalCulatorform extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            validator: {
                dob: '',
                policy: '',
                term: '',
                sum_assured: '',
                parentage: '',
                accidental_cover: '',
                mode: '',
            },
            message: '',
            message_type: '',
            policy: {},
            terms: {},
            modedata: {},
            styleinfo: {
                accidental: 'none',
                licterm: 'block',
                parentage: 'none',
            },
            calculation: '',

        };
        this.refs = React.createRef();

        this.handleDateChange = this.handleDateChange.bind(this);
    }

    static getDerivedStateFromProps(props, state) {

        return {
            lang: props.lang
        }
    }

    handleMessageClose = () => {
        this.setState({ message: '', message_type: '' })
    }

    handleDateChange(date) {
        this.setState({
            startDate: date
        })
    }

    handleSubmit = () => {

        var parentage = $("#parent_age").val();
        var styleinfo = this.state.styleinfo;
        const userFormData = {
            dob: $("#dateofbirth").val(),
            policy: this.policy.value,
            term: styleinfo.licterm == 'block' ? this.term.value : 0,
            sum_assured: this.sum_assured.value,
            parentage: (parentage && styleinfo.parentage == 'block') ? parentage : 0,
            accidental_cover: styleinfo.accidental == 'block' ? this.accidental_cover.value : 0,
            mode: this.mode.value,
            phone_number: ''
        }

        const resetValidator = {
            dob: '',
            policy: '',
            term: '',
            sum_assured: '',
            parentage: '',
            accidental_cover: '',
            mode: '',
        }
        var validation = {};

        if (userFormData.dob == '') {
            validation.dob = 'This field is required.';
        }

        if (userFormData.policy == '') {
            validation.policy = 'This field is required.';
        }

        if (userFormData.term == '' && styleinfo.licterm == 'block') {
            validation.term = 'This field is required.';
        }
        if (userFormData.sum_assured == '') {
            validation.sum_assured = 'This field is required.';
        }
        if (userFormData.parentage == '' && styleinfo.parentage == 'block') {
            validation.parentage = 'This field is required.';
        }
        if (userFormData.accidental_cover == '' && styleinfo.accidental == 'block') {
            validation.accidental_cover = 'This field is required.';
        }
        if (userFormData.mode == '') {
            validation.mode = 'This field is required.';
        }

        if (Object.keys(validation).length) {
            this.setState({ validator: { ...resetValidator, ...validation }, message: '' });

        }
        else {

            this.props.getCalculations(userFormData).then((res) => {

                this.sum_assured.value = '';
                this.accidental_cover.value = '';
                this.mode.value = '';
                $("#parent_age").val('');
                $("#dateofbirth").val('');

                this.setState({ calculation: res, message: '', message_type: 'success', validator: { ...resetValidator } })
            })
        }
    }

    handleValidatonRest = () => {
        const resetValidator = {
            dob: '',
            policy: '',
            term: '',
            sum_assured: '',
            parentage: '',
            accidental_cover: '',
            mode: '',
        }
        this.setState({ validator: { ...resetValidator } });
    }

    handlePoliciesBasedOnAge = () => {
        this.handleValidatonRest();
        var dob = $("#dateofbirth").val();

        if (dob) {
            this.props.getPoliciesBasedOnAge({ dob: dob }).then(({ policies }) => {
                this.setState({ policy: policies });
            });
        }
    }
    handleTermsBasedOnPolicy = () => {
        this.handleValidatonRest();
        var dob = $("#dateofbirth").val();
        var policy = this.policy.value;
        if (dob && policy) {
            this.props.getTermsBasedOnPolicy({ dob: dob, policy: policy }).then(({ terms }) => {
                this.setState({ terms: terms })
            });
            this.handleModeData();
            this.handleOptionShowHide();
        }
    }
    handleSumAssuredValidation = () => {

        //this.handleValidatonRest();
        var policy = this.policy.value;
        var sum_assured = this.sum_assured.value;

        if (!policy) {
            this.sum_assured.value = '';
            this.setState({
                validator: {
                    ...this.state.validator,
                    policy: 'First you have to select policy'
                }
            })

            return;
        }

        if (sum_assured && policy) {
            this.props.getSumAssuredValidation({ policy: policy, sum_assured: sum_assured }).then((data) => {
                // console.log("getSumAssuredValidation",data);

                if (data.status == 'invalid') {
                    this.setState({
                        validator: {
                            ...this.state.validator,
                            sum_assured: data.msg
                        }
                    })
                }
                else {
                    this.setState({
                        validator: {
                            ...this.state.validator,
                            sum_assured: ''
                        }
                    })
                }

                //this.setState({terms:terms})
            });
        }
    }

    handleModeData = () => {
        var modeData;
        var policy = this.policy.value;
        if (!policy) {
            modeData = {};
        }
        else if (policy == '803') {
            modeData = { "5": "Single" };
        }
        else if (policy == '8141') {
            modeData = { "5": "Single" };
        }
        else if (policy == '809') {
            modeData = { "5": "Single" };
        }
        else if (policy == '811') {
            modeData = { "1": "Yearly", "2": "Half Yearly" };
        }
        else {
            modeData = { "1": "Yearly", "2": "Half Yearly", "3": "Quarterly", "4": "Monthly" };
        }

        this.setState({ modedata: modeData });
    }

    handleOptionShowHide = () => {

        var policy = this.policy.value;
        let conditionalData = {
            accidental:'block',
            licterm:'block',
            parentage:'none',
        }
       
        if (!policy || policy == '807' || policy == '803' || policy == '811'|| policy == '816' || policy == '8141' || policy == '809') {
            conditionalData.accidental = 'none';
        }
       


        if (policy == '807') {
            conditionalData.parentage = 'block';
            conditionalData.licterm = 'none';
        } else {
            conditionalData.parentage = 'none';
            conditionalData.licterm = 'block';
        }

        this.setState({
                styleinfo: {
                    ...this.state.styleinfo,
                    ...conditionalData
                }
            });
    }

    render() {

        const contents = this.props.data.content;
        const { validator, policy, terms, modedata, styleinfo, calculation } = this.state;

        const policy_data = Object.entries(policy);
        const terms_data = Object.entries(terms);
        const mode_data = Object.entries(modedata);
        console.log("styleinfo =", styleinfo);
        const lang = this.props.lang;
        return (
            <Fragment>

                <div className="contact-from">
                
                    {lang === 'en' && <h1>{contents ? contents.short_description : ''}</h1>}
                    {lang === 'bn' && <h1>{contents ? contents.bn_short_description : ''}</h1>}

                    <div className="contact-main">

                        <div className="row">
                            {this.state.message != '' && this.state.message_type == 'success' && <div className="col-sm-12" >
                                <div className="alert  alert-success alert-dismissible fade show" role="alert">
                                    {this.state.message}
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => this.handleMessageClose()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>}
                            {this.state.message != '' && this.state.message_type == 'danger' && <div className="col-sm-12">
                                <div className="alert  alert-danger alert-dismissible fade show" role="alert">
                                    {this.state.message}
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => this.handleMessageClose()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>}
                        </div>

                        <div className='row'>
                            <div className='col-md-7'>
                                <form>
                                    <div className="form-group">
                                        <label>
                                            <LangData keyname="label_premium_calculator_dob" />
                                            <span>*</span></label>

                                        <DateInput handlePoliciesBasedOnAge={() => this.handlePoliciesBasedOnAge()}
                                            id="dateofbirth"
                                        />

                                        {validator.dob && <span className="help-block form-text text-danger">{validator.dob}</span>}



                                    </div>

                                    <div className="form-group">
                                        <label><LangData keyname="label_premium_calculator_plan_name" /><span>*</span></label>
                                        <select ref={(input) => this.policy = input} className={validator.policy ? 'form-control from-style input-error' : 'form-control from-style'} onChange={() => this.handleTermsBasedOnPolicy()}>
                                            <option value="">Select Policy</option>
                                            {policy_data.length && <Fragment>

                                                {policy_data.map((row, key) => {
                                                    return (
                                                        <option value={row[0]} key={key}>{row[1]}</option>
                                                    )
                                                })}
                                            </Fragment>}
                                        </select>

                                        {validator.policy && <span className="help-block form-text text-danger">{validator.policy}</span>}
                                    </div>
                                    <div className="form-group" style={{ display: styleinfo.licterm }}>
                                        <label><LangData keyname="label_premium_calculator_term" /> <span>*</span></label>

                                        <select ref={(input) => this.term = input} className={validator.term ? 'form-control from-style input-error' : 'form-control from-style'}>
                                            <option value="">Select terms</option>

                                            {terms_data.length && <Fragment>

                                                {terms_data.map((row, key) => {
                                                    return (
                                                        <option value={row[0]} key={key}>{row[1]}</option>
                                                    )
                                                })}
                                            </Fragment>}

                                        </select>
                                        {validator.term && <span className="help-block form-text text-danger">{validator.term}</span>}
                                    </div>
                                    <div className="form-group" style={{ display: styleinfo.parentage }}>
                                        <label><LangData keyname="label_premium_calculator_date_of_birth_parents" /><span>*</span></label>

                                        <DateInput
                                            id="parent_age"
                                        />

                                        {validator.parentage && <span className="help-block form-text text-danger">{validator.parentage}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label><LangData keyname="label_premium_calculator_sum_assured" /><span>*</span></label>

                                        <input type="text" ref={(input) => this.sum_assured = input} className={validator.sum_assured ? 'form-control from-style input-error' : 'form-control from-style'} placeholder="Sum assured" onInput={() => this.handleSumAssuredValidation()} />
                                        {validator.sum_assured && <span className="help-block form-text text-danger">{validator.sum_assured}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label><LangData keyname="label_premium_calculator_mode" /><span>*</span></label>

                                        <select ref={(input) => this.mode = input} className={validator.mode ? 'form-control from-style input-error' : 'form-control from-style'}>
                                            <option value="">Select Mode</option>

                                            {mode_data.length && <Fragment>

                                                {mode_data.map((row, key) => {
                                                    return (
                                                        <option value={row[0]} key={key}>{row[1]}</option>
                                                    )
                                                })}
                                            </Fragment>}

                                        </select>
                                        {validator.mode && <span className="help-block form-text text-danger">{validator.mode}</span>}
                                    </div>
                                    <div className="form-group" style={{ display: styleinfo.accidental }}>
                                        <label><LangData keyname="label_premium_calculator_accidental_coverage" /><span>*</span></label>

                                        <select ref={(input) => this.accidental_cover = input} className={validator.accidental_cover ? 'form-control from-style input-error' : 'form-control from-style'}>
                                            <option value="">Select</option>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        {validator.accidental_cover && <span className="help-block form-text text-danger">{validator.accidental_cover}</span>}
                                    </div>
                                </form>

                                <div className="submit">

                                    <input type="button" value={lang ==='bn'?'ক্যালকুলেট':'Calculate'} className="btn submit-button" name="submit" onClick={() => this.handleSubmit()} />

                                </div>
                            </div>
                            <div className='col-md-5'>
                                {calculation && <div className="calculated-result">

                                    <p> <span className='label'><LangData keyname="label_premium_calculator_plan_name" />: </span> {calculation.policy}</p>
                                    <p><span className='label'> <LangData keyname="label_premium_calculator_customer_age" />:</span> {calculation.age}</p>
                                    <p> <span className='label'><LangData keyname="label_premium_calculator_sum_assured" />:</span> {calculation.sum_assured}</p>
                                    <p> <span className='label'><LangData keyname="label_premium_calculator_term" />:</span> {calculation.term}</p>
                                    <p> <span className='label'><LangData keyname="label_premium_calculator_mode" />:</span> {calculation.mode}</p>
                                    <p><span className='label'><LangData keyname="label_premium_calculator_approximate_premium" />: </span>{calculation.premium_amount}</p>
                                </div>}
                            </div>
                        </div>
                    </div>






                </div>

            </Fragment>
        );
    }
}
const mapStateToProps = state => ({
    lang: state.utils.lang,
})
const mapDispatchToProps = (dispatch) => ({
    setPath: (requestData) => { dispatch(setPath(requestData)) },
    setLayout: (requestData) => { dispatch(setLayout(requestData)) },
    setPathLayout: (requestData) => { dispatch(setPathLayout(requestData)) },
    sendContactus: (requestData) => { dispatch(sendContactus(requestData)) },
    getPoliciesBasedOnAge: (requestData) => dispatch(getPoliciesBasedOnAge(requestData)),
    getTermsBasedOnPolicy: (requestData) => dispatch(getTermsBasedOnPolicy(requestData)),
    getSumAssuredValidation: (requestData) => dispatch(getSumAssuredValidation(requestData)),
    getCalculations: (requestData) => dispatch(getCalculations(requestData)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PremiumcalCulatorform);